/* eslint-disable no-debugger */
import useKendoReportData from '@usas/ui-web/components/embeddedReports/kendoReports/useKendoReportData';

const useImxCerts = (reportInfoId, reportParameters) => {
  const {
    reportData,
    isLoaded
  } = useKendoReportData(reportInfoId, reportParameters);

  return { reportData: reportData.filter(r => r.totalScore > 0), isLoaded };
};

export default useImxCerts;